import { NoHydration } from 'solid-js/web';
import { TopoBg } from '../../components/topo-bg';
import type { ParentProps } from 'solid-js';
import type { RouteDefinition } from '@solidjs/router';

export default function AuthPages(props: ParentProps) {
	return (
		<div class="relative flex h-svh items-center justify-center">
			<NoHydration>
				<TopoBg placement="top" class="absolute inset-x-0 top-0 z-0 h-64 w-screen" />
			</NoHydration>
			<div class="w-full max-w-2xl">{props.children}</div>
		</div>
	);
}

export const route = {
	info: { nav: { appearance: 'none', hero: false }, banner: { hide: true } },
} satisfies RouteDefinition;
